import {
  withResponsiveOptions,
  withBreakpointObserver,
  getClosestParent,
} from '@studiometa/js-toolkit';
import { Menu as MenuCore } from '@studiometa/ui';
import MenuList from './MenuList.js';

/**
 * Menu class.
 */
export default class Menu extends withResponsiveOptions(withBreakpointObserver(MenuCore), {
  responsiveOptions: ['mode'],
}) {
  static config = {
    ...MenuCore.config,
    emits: ['open', 'close'],
    components: {
      ...MenuCore.config.components,
      MenuList,
      Menu,
    },
  };

  /**
   * isOpen
   * @returns {boolean}
   */
  get isOpen() {
    return this.$isMounted ? (this.menuList?.isOpen ?? false) : false;
  }

  /**
   * Emit open event.
   * @param {{ target: MenuList }} props
   */
  onMenuListItemsOpen(props) {
    if (getClosestParent(props.target, this.constructor) === this) {
      this.$emit('open', { event: props });
    }

    super.onMenuListItemsOpen(props);
  }

  /**
   * Emit close event.
   *
   * `Menu` de `@studiometa/ui` n'implémente plus `onMenuListItemsClose` depuis la 1.2.0,
   * l'appel au parent est donc optionnel — il reste là si le hook revient un jour.
   * @param {{ target: MenuList }} props
   */
  onMenuListItemsClose(props) {
    if (getClosestParent(props.target, this.constructor) === this) {
      this.$emit('close');
    }

    super.onMenuListItemsClose?.(props);
  }
}
